import script from "./MaterialPlans.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialPlans.vue?vue&type=script&setup=true&lang=js"

import "./MaterialPlans.vue?vue&type=style&index=0&id=76c7c032&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/online-3d-editor-laozicloud3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76c7c032"]])

export default __exports__